import obfuscate from './obfuscate';
export default obfuscate;
